import {
  validatePhone,
  validateRequired
} from '../../../helpers/formValidation'
import { CourseSelectOptions, ValidateInstituteForm } from './typings'
import { AdditionalCourse, Course } from '../../../redux/coachingCenter/types'
import { format } from 'date-fns'
import { DATE_FORMAT_YYYYMMDD } from '../../../const/dateFormat'

export const validateInstituteForm = ({
  values,
  errors,
  field
}: ValidateInstituteForm): Record<string, string> => {
  const formErrors: Record<string, string> = { ...errors }
  const {
    coachingCentreName,
    coachingCenterCode,
    address1,
    country,
    state,
    city,
    zipCode,
    mobileNumber,
    status,
    studentCount,
    teacherCount
  } = values || {}

  switch (field) {
    case 'coachingCentreName':
      formErrors['coachingCentreName'] = validateRequired(coachingCentreName)
      break
    case 'coachingCenterCode':
      formErrors['coachingCenterCode'] = validateRequired(coachingCenterCode)
      break
    case 'address1':
      formErrors['address1'] = validateRequired(address1)
      break
    case 'country':
      formErrors['country'] = validateRequired(country)
      break
    case 'state':
      formErrors['state'] = validateRequired(state)
      break
    case 'city':
      formErrors['city'] = validateRequired(city)
      break
    case 'zipCode':
      formErrors['zipcode'] = validateRequired(zipCode)
      break
    case 'mobileNumber':
      formErrors['mobileNumber'] = validatePhone(mobileNumber)
      break
    case 'status':
      formErrors['status'] = validateRequired(status)
      break
    case 'studentCount':
      formErrors['studentCount'] = validateRequired(studentCount)
      break
    case 'teacherCount':
      formErrors['teacherCount'] = validateRequired(teacherCount)
      break
    default:
      formErrors['coachingCentreName'] = validateRequired(coachingCentreName)
      formErrors['coachingCenterCode'] = validateRequired(coachingCenterCode)
      formErrors['address1'] = validateRequired(address1)
      formErrors['country'] = validateRequired(country)
      formErrors['state'] = validateRequired(state)
      formErrors['city'] = validateRequired(city)
      formErrors['zipCode'] = validateRequired(zipCode)
      formErrors['mobileNumber'] = validatePhone(mobileNumber)
      formErrors['status'] = validateRequired(status)
      formErrors['studentCount'] = validateRequired(studentCount)
      formErrors['teacherCount'] = validateRequired(teacherCount)
  }

  return formErrors
}
const comparer = (additionalCourses: AdditionalCourse[]) => {
  return (course: Course) => {
    return (
      additionalCourses.filter((additionalCourse) => {
        return additionalCourse.course?.id == course.id
      }).length == 0
    )
  }
}

export const getSelectedCourseList = (coursesList: CourseSelectOptions[]) => {
  return coursesList
    .filter((course) => course.selected && course.expiryDate)
    .map((course) => ({
      courseId: course.id,
      expiryDate: format(course.expiryDate, DATE_FORMAT_YYYYMMDD)
    }))
}

export const getCourseList = (
  courses: Course[],
  additionalCourses: AdditionalCourse[]
): Array<CourseSelectOptions> => {
  const matchingCourse = courses
    .filter((course) =>
      additionalCourses.some(
        (additionalCourse) => course.id === additionalCourse.course?.id
      )
    )
    .map((course) => {
      const expiryDate = additionalCourses.filter(
        (additionalCourse) => course.id === additionalCourse.course?.id
      )[0]?.expiryDate

      return {
        id: course.id,
        name: course.courseName,
        selected: true,
        expiryDate: expiryDate && new Date(expiryDate)
      }
    })

  const nonMatchingCourse = courses
    .filter(comparer(additionalCourses))
    .map((course) => {
      return {
        id: course.id,
        name: course.courseName,
        selected: false
      }
    })

  return [...matchingCourse, ...nonMatchingCourse]
}
